export const PREVIEW_STICKY_Z_INDEX = {
  toolbar: 11,
  nav: 10,
} as const;
